<template>
  <a-modal
    title="操作指引"
    :visible="value"
    :footer="null"
    @cancel="$emit('input', false)"
  >
    <a-table
      :columns="columns"
      :data-source="dataList"
      :pagination="false"
    >
      <span slot="roleName" slot-scope="roleName">
        {{ roleName }}
      </span>
      <span slot="operation" slot-scope="text, record">
        <a @click="downloadOperationGuide(record.guideUrl)">查看操作指引</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: '角色',
    dataIndex: 'roleName',
    key: 'roleName',
    width: 100,
    scopedSlots: { customRender: 'roleName' }
  },
  {
    title: '操作',
    key: 'operation',
    width: 50,
    scopedSlots: { customRender: 'operation' }
  }
]
export default {
  props: {
    platForm: {
      type: Object,
      default () {
        return {}
      }
    },
    value: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  data () {
    return {
      columns,
      dataList: []
    }
  },
  watch: {
    value: {
      handler (bool) {
        if (!bool) {
          return
        }
        this.dataList = []
        for (const key in this.platForm.operationGuideDownloadUrl) {
          this.dataList.push({
            roleName: key,
            guideUrl: this.platForm.operationGuideDownloadUrl[key]
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    downloadOperationGuide (guideUrl) {
      window.open(guideUrl)
    }
  }
}
</script>
